export default {
  en: {
    back: 'Back',
    general: 'General',
    agent: 'Agent',
    rateCode: 'Rate Code',
    promotion: 'Promotion',
    supplement: 'Supplement',
    transfer: 'Transfer',
    backToContractList: 'Back to contract list',
    previewContract: 'Preview Contract',
    saveDraft: 'Save Draft',
    saveContract: 'Save Contract',
    saveContractSuccessTitle: 'Success',
    saveContractSuccessMessage: 'Save Contract Success.'
  },
  th: {
    back: 'กลับ',
    general: 'ทั่วไป',
    agent: 'ตัวแทน',
    rateCode: 'ประเภทเรท',
    promotion: 'โปรโมชั่น',
    supplement: 'รายการเพิ่มเติม',
    transfer: 'รถรับส่ง',
    backToContractList: 'Back to contract list',
    previewContract: 'ดูตัวอย่างสัญญา',
    saveDraft: 'บันทึกฉบับร่าง',
    saveContract: 'บันทึกสัญญา',
    saveContractSuccessTitle: 'สำเร็จ',
    saveContractSuccessMessage: 'บันทึกสัญญาสำเร็จ.'
  }
}
